import { Typography } from '@mui/material';
import Breadcrumbs from 'components/breadcrumbs';
import { useAccountState } from 'contexts/account/account-context';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';
import BluViuNutritionTabsHeader from 'views/bluviu-nutrition/components/bluviu-nutrition-tabs-header';
import EditR2CalibrationContainer from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/edit-r2-calibration';
import EditSimpleCalibrationContainer from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/edit-simple-calibration';
import { CalibrationProvider, useCalibrationState } from 'views/bluviu-nutrition/features/calibrations/context/calibration-context';
import { CalibrationListProvider } from 'views/bluviu-nutrition/features/calibrations/context/calibration-list-context';
import { CalibrationType } from 'views/bluviu-nutrition/features/calibrations/types/calibration-type.enum';
import { CalibrationsParams } from 'views/bluviu-nutrition/features/calibrations/types/calibrations-params.type';

const EditCalibration = () => {
  const params = useParams<CalibrationsParams>();
  const location = useLocation<{ siteName: string }>();
  const {
    account: { company },
  } = useAccountState();

  const {
    simpleCalibrationQuery: { data: calibration },
    r2CalibrationQuery: { data: r2Calibration },
  } = useCalibrationState();

  return (
    <>
      <BluViuNutritionTabsHeader
        intro={
          <Typography color="white">
            <FormattedMessage id={`general.confidential`} />
          </Typography>
        }
        utils={
          <Breadcrumbs
            crumbs={
              !!params.globalSiteId
                ? [
                    {
                      text: location.state?.siteName || company?.addressAccess.find((s) => s.id === params.globalSiteId)?.name || '', // backup from location state
                      url: `${params.globalSiteId}`,
                    },
                    {
                      text: (params.calibrationType === CalibrationType.MULTI ? r2Calibration?.name : calibration?.name) || '',
                      url: `${params.globalSiteId}/${params.calibrationType}/${params.calibrationId}`,
                    },
                  ]
                : undefined
            }
          />
        }
      />
      {params.calibrationType === CalibrationType.MULTI ? <EditR2CalibrationContainer /> : <EditSimpleCalibrationContainer />}
    </>
  );
};

const EditCalibrationContainer = () => {
  return (
    <CalibrationListProvider>
      <CalibrationProvider>
        <EditCalibration />
      </CalibrationProvider>
    </CalibrationListProvider>
  );
};

export default React.memo(EditCalibrationContainer);
